import { 
  FormControl, 
  Select, 
  MenuItem, 
  Box, 
  Typography, 
  SelectChangeEvent
} from '@mui/material';
import { useThemeContext } from '../../theme/useThemeContext';
import { AppThemeMode } from '../../theme/theme';

const SeasonalThemeSelector = () => {
  const { mode, setMode } = useThemeContext();

  const handleModeChange = (event: SelectChangeEvent<AppThemeMode>) => {
    setMode(event.target.value as AppThemeMode);
  };

  const modes: { value: AppThemeMode; label: string; description: string }[] = [
    { value: 'system', label: 'System', description: 'Follow your device theme' },
    { value: 'light', label: 'Light', description: 'Clean bright interface' },
    { value: 'dark', label: 'Dark', description: 'Neutral dark interface' },
    { value: 'tech', label: 'Tech', description: 'Blue and purple neon interface' },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 200 }}>
      <FormControl size="small">
        <Select
          value={mode}
          onChange={handleModeChange}
          displayEmpty
          sx={{
            minWidth: 140,
            '& .MuiSelect-select': {
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            },
          }}
        >
          {modes.map((themeMode) => (
            <MenuItem key={themeMode.value} value={themeMode.value}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography variant="body2">
                  {themeMode.label}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {themeMode.description}
                </Typography>
              </Box>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default SeasonalThemeSelector;
